import ReactDom from "react-dom";
import ReferenceLink from "./ReferenceLink.jsx";

export default function renderReferenceLinks() {
  if (!inExperienceEditorMode()) {
    document.querySelectorAll(".reference").forEach((target) => {
      const referenceName = target.textContent;

      const referenceItem = document.getElementById("ref" + referenceName);
      const referenceText = referenceItem.parentElement.querySelector(
        ".references__list-text",
      ).innerText;

      const data = {
        referenceName,
        referenceText,
      };

      // react does not render in the rich text editor view.
      // we don't want to insert a mount there because it will add whitespace which editors might delete,
      // and because we'd need to update all existing reference links across the site.
      // in the actual page, we'll replace the reference link and only use the react component
      const mount = document.createElement("div");
      mount.classList.add("js-reference-link-mount");
      target.parentElement.replaceWith(mount);

      ReactDom.render(<ReferenceLink {...data} />, mount);
    });
  }

  function inExperienceEditorMode() {
    return typeof Sitecore !== "undefined" && Sitecore?.PageModes?.PageEditor;
  }
}
